import { PostgrestResponse } from '@supabase/supabase-js';
import { IProdutosGrupos } from '../../../types/tables/IProdutosGrupos';
import { BaseMultiTenantService } from '../base/BaseMultiTenantService';

/**
 * Serviço para gerenciamento de grupos de produtos com isolamento multi-tenant
 * Gerencia categorização principal dos produtos (Bebidas, Lanches, Doces, etc.)
 */
export class ProdutosGruposService extends BaseMultiTenantService<IProdutosGrupos> {
     constructor() {
          super('produtos_grupos', ['descricao'], 'fk_id_organizacao');
     }

     /**
      * Busca grupos com contagem de produtos
      */
     async getAllWithProductCount(organizationId: number): Promise<PostgrestResponse<IProdutosGrupos[]>> {
          return await this.client
               .from(this.tableName)
               .select(
                    `
                    *,
                    produtos_count:produtos(count)
               `,
               )
               .eq(this.organizationIdField, organizationId)
               .is('deleted_at', null)
               .order('descricao', { ascending: true });
     }

     /**
      * Busca grupos com seus subgrupos
      */
     async getAllWithSubGrupos(organizationId: number): Promise<PostgrestResponse<IProdutosGrupos[]>> {
          return await this.client
               .from(this.tableName)
               .select(
                    `
                    *,
                    produtos_sub_grupos(*)
               `,
               )
               .eq(this.organizationIdField, organizationId)
               .is('deleted_at', null)
               .order('descricao', { ascending: true });
     }

     /**
      * Cria grupos padrão para uma nova organização
      */
     async criarGruposPadrao(organizationId: number, userId?: number): Promise<any[]> {
          const gruposPadrao = [{ descricao: 'Bebidas' }, { descricao: 'Lanches' }, { descricao: 'Doces' }, { descricao: 'Salgados' }, { descricao: 'Frutas' }, { descricao: 'Refeições' }, { descricao: 'Sobremesas' }, { descricao: 'Outros' }];

          const resultados = [];

          for (const grupo of gruposPadrao) {
               try {
                    const resultado = await this.create(grupo, organizationId, userId);
                    resultados.push(resultado);
               } catch (error) {
                    console.error(`Erro ao criar grupo ${grupo.descricao}:`, error);
               }
          }

          return resultados;
     }

     /**
      * Verifica se o grupo pode ser excluído
      */
     async canDelete(id: number, organizationId: number): Promise<{ canDelete: boolean; reason?: string }> {
          // Verificar se há produtos neste grupo
          const { data: produtos } = await this.client.from('produtos').select('id').eq('fk_id_produto_grupo', id).eq('fk_id_organizacao', organizationId).is('deleted_at', null);

          if (produtos && produtos.length > 0) {
               return { canDelete: false, reason: 'Existem produtos vinculados a este grupo' };
          }

          // Verificar se há subgrupos
          const { data: subgrupos } = await this.client.from('produtos_sub_grupos').select('id').eq('fk_id_produto_grupo', id).eq('fk_id_organizacao', organizationId).is('deleted_at', null);

          if (subgrupos && subgrupos.length > 0) {
               return { canDelete: false, reason: 'Existem subgrupos vinculados a este grupo' };
          }

          return { canDelete: true };
     }
}

export const produtosGruposService = new ProdutosGruposService();
